// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  list-style-type: none;
  box-sizing: border-box;

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    &.nav-bar-l1.content-wrapper {
      display: flex;
      flex-direction: column;
      ${(props) => (props.isNewNavigationImagesEnabled ? `display: grid;` : 'display: flex;')}
      ${(props) => (props.isNewNavigationImagesEnabled ? `grid-template-columns: auto auto;` : '')}
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 0 15px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    &.center-nav {
      justify-content: center;
    }
  }
  .nav-bar-l2 {
    min-height: -webkit-fill-available;
  }
  .nav-bar-l2.nav-bar-l2-panel {
    min-height: auto;
  }
  .image-bar-separator {
    @media ${(props) => props.theme.mediaQuery.large} {
      bottom: 358px;
      width: 100%;
      position: absolute;
      left: 0;
      top: 111px;
      margin: 0;
      border: none;
      border-top: 1px solid ${(props) => props.theme.colorPalette.gray[3200]};
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      ${(props) => (props.isNewNavigationImagesEnabled ? `display: none;` : '')}
    }
  }
`;
